<template >
    <div class="skills-container">
            <div class="skills-content">
                
                <div class="skills-header fadeInDown animated">
                      
                        <button :class="{'active-btn': (chart==1)}" @click="chart=1">
                          <i class="fas fa-code" style="font-size: 18px;"></i>
                          <p style="font-size: 10px; font-family:comfortaa;">CODING</p>
                        </button>
                        <button :class="{'active-btn': (chart==2)}" @click="chart=2">
                        <i class="far fa-object-group" style="font-size: 18px;"></i>
                        <p style="font-size: 10px;font-family:comfortaa;">GRAPHICS</p>
                        </button>
                </div>

                <div class="wrapper">
                  <div class="chart-container" v-show="chart==1">
                      <canvas id="codingChart" width="500" height="500"></canvas>
                  </div>

                  <div class="chart-container" v-show="chart==2">
                      <canvas id="graphicsChart"  width="500" height="500"></canvas>
                  </div>
                </div>

            </div>
                
    </div>
  

</template>






<script >

import Chart from 'chart.js';

Chart.defaults.global.defaultFontColor = 'black';
Chart.defaults.global.defaultStrokeColor = 'black';




  export default {
    name: 'skills',
    data(){
      return {
        chart: 1
      }
    },


    mounted(){
      Chart.defaults.global.defaultFontFamily = "comfortaa";
    
    
      //coding chart
      var ctx = document.getElementById("codingChart");
      var codingChart = new Chart(ctx, {
        type: 'radar',
        


        data: {

          labels: ["Vue.js", "React.js", "Html", "Css",["JavaScript", "      ES6"], "Sass", "Bootstrap", "Wordpress",  "webpack"  , "canvas", "node.js" , "Git" ],
          datasets: [{
            label: '# of Votes',
            data: [4.5, 4, 4.9, 4.9, 4.5, 4.5, 4.5, 4, 3.5, 3, 3, 4],
             
             
            backgroundColor: [
            'rgba(253,121,131,0.3)',
            ],
            borderColor:"#ff4d5a",
            borderWidth: 1
          }]
        },
        options: {
          responsive : true,
           scale: {
                 ticks: {
                    display: false,
                    beginAtZero: true,
                    max: 5
                },
              pointLabels: {
                fontSize: 12,
               },
               gridLines: { 
                color: "#2f2f2f",
                 },
               angleLines: { 
                color: "#2f2f2f",
                 },  
            },
            legend: {
            display: false
          },


          tooltips : {
            enabled : false
          }
        }
      });

      // graphics chart
      var ctx2 = document.getElementById("graphicsChart");
      var graphicsChart = new Chart(ctx2, {
        type: 'radar',
        data: {
          labels: ["Photoshop", "Illustrator", "Sketch","After effect"],
          datasets: [{
            label: '# of Votes',
            data: [4.5,4.5,4.5,3],
            backgroundColor: [
            'rgba(253,121,131,0.3)',
            ],
            borderColor:"#ff4d5a",
            borderWidth: 1
          }]
        },
        options: {
          responsive : true,
           scale: {
                 ticks: {
                    display: false,
                    beginAtZero: true,
                    max: 5
                },
              pointLabels: {
                fontSize: 12,
                  },
              gridLines: { 
                color: "#2f2f2f",
                 },
               angleLines: { 
                color: "#2f2f2f",
                 },     
            },
            legend: {
            display: false
          },
          tooltips : {
            enabled : false
          }
        }
      });

    }
  }
  
</script>



<style>

 @import url("https://use.fontawesome.com/releases/v5.0.13/css/all.css");

.skills-container {
  width: 100%;
  margin-top: 13vh;
}

.skills-content{  
  /* position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  margin-top: 5vh; */
  box-sizing: border-box;
  width: 100%;
  margin: auto;
  font-family:comfortaa;
  }

.skills-header{
  text-align: center;
  transform: translate(-50%);
  margin-bottom: -30px;
}


.skills-header>button{
      background-color: transparent;      
      text-align: center;
      border:none;
      cursor: pointer;
      outline: none;
      font-size: 20px;  
      margin-left: 0px;
      color: #474747;     
  }

.skills-header>.active-btn{
      background-color: transparent;
      text-align: center;
      border:none;
      cursor: pointer;
      outline: none;
      margin-left: 0px;
      color: #ff4d5a;     
  }

.wrapper{
  position: relative;
  margin: auto;
  padding: 1rem;
  max-width: 600px;
}

.chart-container{
  min-width: 250px;
  font-family:comfortaa;
}


@media(max-width:1069px){
    
  .skills-content{
    font-family:comfortaa;
    }
  }

    
</style>


// WEBPACK FOOTER //
// src/components/Skills.vue